export type GtagWindow = Window & {
  gtag?: (...args: unknown[]) => void;
};

export function trackCtaClick(
  cta_location: string,
  cta_label: string,
  destination_url: string,
  post_slug?: string
) {
  if (typeof window === 'undefined') return;

  const eventParams: Record<string, string> = {
    cta_location,
    cta_label,
    destination_url
  };

  if (post_slug) {
    eventParams.post_slug = post_slug;
  }

  (window as GtagWindow).gtag?.('event', 'cta_click', eventParams);
}
